<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>
    <span class="navbar-toggler-icon"></span>
  </button>
  <span class="navbar-brand"></span>
  <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a id="logOutDropDown" class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
        aria-expanded="false" dropdownToggle (click)="false">
        <i class="icon-settings"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <a id="logOutButton" class="dropdown-item" (click)="resetPassword()"><i class="fa fa-key"></i> Reset
          Password</a>
        <a id="logOutButton" class="dropdown-item" (click)="auth.signOut()"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </li>
  </ul>
</header>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-header/app-header.component.html